// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avenue -> repli-sandbox-avenue-avenue -> roy-roy-roy-roy
// Generated: 2026-09-23T20:46:08.288Z
// Counts: 4 design, 26 content, 12 slot group, 2 collection binding, 6 section, 8 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "VALUE",
    "value": "#fa0000",
    "mappedField": null
  },
  "design._site.color.linkHover": {
    "cssVariable": "--vibe-color-link-hover",
    "overrideType": "VALUE",
    "value": "#15a273",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_full_address"
  },
  "footer.copyright": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_copyright"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": "virtual tour",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "adtaxi-tracking.profile": {
    "overrideType": "VALUE",
    "customValue": "liveattimberlakeapts.com",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "sDFasdf",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "multihub_agency_id"
  },
  "contactform.form.captcha_enabled": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.show_success_icon": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.success_message": {
    "overrideType": "VALUE",
    "customValue": "Thank You For Connecting With Us",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.success_subtext": {
    "overrideType": "VALUE",
    "customValue": "We appreciate your inquiry and will be with you soon.",
    "generatedValue": null,
    "mappedField": null
  },
  "cort-lead-form.form_id": {
    "overrideType": "VALUE",
    "customValue": "4Marq_SAgf9G5RQM8bh773hCkR",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "Make Yourself at Home lklj",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_tag_manager"
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Elevate your lifestyle in Lower Queen Annes newest premier residence, opening February 2025. From panoramic views of the Space Needle, city skyline, and Mount Rainier to the charm of Queen Anne Hill, 110 Roy offers a slice of Seattles best.Your brand-new home awaits, featuring thoughtfully designed spaces and elevated amenities: Chef-style kitchens with quartz countertops, stainless steel appliances, and full-height tile backsplashes Air Conditioning in every home Expansive Skyview Terrace with sweeping views, a fire pit, grilling stations, and al fresco diningExclusive resident lounge and 24-hour fitness studioOnsite retail for your convenienceShare your contact information to get exclusive previews, tour invites, and first dibs on leasing. Be part of Seattle's most anticipated launch! asdf</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "110 Royyy",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-49a5-7587-b84e-e2aedab919be.webp"
      }
    }
  },
  "footer.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo"
      }
    }
  },
  "footer.powered_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-fa1c-74bf-a89d-68fd979db7af.webp"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "ctasection.card3_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "contactform.form.success_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Back To Overview"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/interactive-map"
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-917e-711d-91f9-d9367a950bff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with a blue tufted sofa, fireplace, and abstract art."
      }
    }
  },
  "hero.cta_link_gallery": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_name"
      }
    }
  },
  "propertyoverview.feature_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019d8e60-be24-7758-ac8a-92ce955c12c1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Man holding coffee and croissant, with his dog looking up at him in a kitchen."
      }
    }
  },
  "propertyoverview.feature_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_website_url"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.apartmentItems": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "adtaxi-tracking",
      "blockId": "adtaxi-tracking",
      "position": 0
    },
    {
      "sectionId": "cort-lead-form",
      "blockId": "cort-lead-form",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 5
    }
  ]
};

export const styleOverrides = {
  "_section.Hero": {
    "properties": {
      "color": "#ff6666",
      "fontWeight": "500"
    }
  },
  "_section.PageBlurb": {
    "properties": {
      "fontWeight": "500"
    }
  },
  "_section.PropertyOverview": {
    "properties": {
      "color": "#00ff62"
    }
  },
  "amenities-blurb.text": {
    "properties": {
      "fontWeight": "900"
    }
  },
  "amenities-hero.title": {
    "properties": {
      "fontWeight": "500"
    }
  },
  "hero.title": {
    "properties": {
      "opacity": "0.45",
      "fontWeight": "900"
    }
  },
  "propertyoverview.description": {
    "properties": {
      "fontWeight": "500",
      "color": "#ff0000",
      "overflow": "visible"
    }
  },
  "propertyoverview.feature_image_1": {
    "properties": {
      "opacity": "0.3"
    }
  }
};
